import { Plus, Upload } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { useItemListContext } from './ItemListProvider';

interface CreateButtonsProps {
  showUpload?: boolean;
  showNewItem?: boolean;
}

export function CreateButtons({ showUpload = true, showNewItem = true }: CreateButtonsProps) {
  const { permissions, openModal } = useItemListContext();
  if (!permissions.canUpload) return null;

  return (
    <div className="fixed bottom-20 right-6 z-40 flex flex-col gap-2">
      {showUpload && (
        <Button
          size="icon"
          className="h-12 w-12 rounded-full shadow-lg"
          onClick={() => openModal('fileUpload')}
          title="Upload file"
        >
          <Upload className="h-5 w-5" />
        </Button>
      )}
      {showNewItem && (
        <Button
          size="icon"
          variant="secondary"
          className="h-12 w-12 rounded-full shadow-lg"
          onClick={() => openModal('newItem')}
          title="New folder or project"
        >
          <Plus className="h-5 w-5" />
        </Button>
      )}
    </div>
  );
}
